import TaskTypes from "@dyl/task-types";
import { getTask } from "@dyl/apiClients/backendApi";
import convertToLocalFormat from "@dyl/pages/Tasks/edit/convertToLocalFormat";
import downloadTextFile from "@dyl/utils/downloadTextFile";

export const exportKeys = (level, componentName) => async (tasks) => {
    const taskDetails = await Promise.all(tasks.map(async (task) => {
        const taskType = TaskTypes[level.label].find(tt => tt.id === task.task_type_id);
        let data = await getTask(level.level_id, task.task_type_id, task.task_id);
        data = convertToLocalFormat(data);
        data = taskType?.convertToLocalFormat?.(data) ?? data;
        return data;
    }));

    let lines = [];
    for (const task of taskDetails) {
        const taskType = TaskTypes[level.label].find(tt => tt.id === task.task_type_id);
        lines.push(`${taskType.label} (${task.task_id_name}):`);
        let index = 0;
        for (const item of task.items) {

            const keyLines = taskType.getKeys(item)?.map(x => '\t\t' + x) ?? [];
            if (keyLines.length > 0) {
                const exampleMapping = task.items.map(x => x.is_example ? 1 : 0);
                const totalExamples = exampleMapping.reduce((acc, item) => acc + item, 0);
                const examplesUntilNow = exampleMapping.slice(0, item.order).reduce((acc, item) => acc + item, 0);
                lines.push(item.is_example
                    ? `Example ${totalExamples === 1 ? '' : examplesUntilNow + 1}:`
                    : `Item ${index + 1 - examplesUntilNow}:`
                );

                lines = lines.concat(keyLines);
                ++index;
            }
        }
        lines.push('');
    }

    const text = lines.join('\n');
    const fileName = `${level.label}-${componentName ?? ''}-keys.txt`;
    console.debug('Lines:');
    console.debug(text);
    downloadTextFile(fileName, text, { type: 'text/txt' });
}